// extracted by mini-css-extract-plugin
module.exports = {"vertical_swticher":"VerticalSwitch_vertical_swticher__qwD_4"};